<div class="container">
  <div class="contact-form-container">
    <div class="panel-container contact-panel">
      <div class="contact-header">
        <span>{{ 'contact.title' | translate }}</span>
      </div>
      <form [formGroup]="contactForm" class="contact-form">
        <!-- Name Field -->
        <div class="form-field">
          <p-float-label variant="in">
            <input
              type="text"
              id="name"
              pInputText
              formControlName="name"
              [placeholder]="'contact.namePlaceholder' | translate"
              [class.error-input]="hasError('name')"
            />
            <label for="name">{{ 'contact.name' | translate }} *</label>
          </p-float-label>
          @if (hasError('name')) {
            <small class="error-message">{{ getErrorMessage('name') }}</small>
          }
        </div>

        <!-- Email Field -->
        <div class="form-field">
          <p-float-label variant="in">
            <input
              type="email"
              id="email"
              pInputText
              formControlName="email"
              [placeholder]="'contact.emailPlaceholder' | translate"
              [class.error-input]="hasError('email')"
            />
            <label for="email">{{ 'contact.email' | translate }} *</label>
          </p-float-label>
          @if (hasError('email')) {
            <small class="error-message">{{ getErrorMessage('email') }}</small>
          }
        </div>

        <!-- Phone Number Field -->
        <div class="form-field">
          <p-float-label variant="in">
            <input
              type="tel"
              id="phoneNumber"
              pInputText
              formControlName="phoneNumber"
              [placeholder]="'contact.phonePlaceholder' | translate"
              [class.error-input]="hasError('phoneNumber')"
            />
            <label for="phoneNumber">{{ 'contact.phone' | translate }} *</label>
          </p-float-label>
          @if (hasError('phoneNumber')) {
            <small class="error-message">{{ getErrorMessage('phoneNumber') }}</small>
          }
        </div>

        <!-- Company Field -->
        <div class="form-field">
          <p-float-label variant="in">
            <input
              type="text"
              id="company"
              pInputText
              formControlName="company"
              [placeholder]="'contact.companyPlaceholder' | translate"
              [class.error-input]="hasError('company')"
            />
            <label for="company">{{ 'contact.company' | translate }} *</label>
          </p-float-label>
          @if (hasError('company')) {
            <small class="error-message">{{ getErrorMessage('company') }}</small>
          }
        </div>

        <!-- Country Field -->
        <div class="form-field">
          <p-ifta-label>
            <p-select
              [options]="countries()"
              formControlName="country"
              optionLabel="name"
              optionValue="code"
              [placeholder]="'contact.countryPlaceholder' | translate"
              [showClear]="true"
              [class.error-input]="hasError('country')"
            />
            <label for="country">{{ 'contact.country' | translate }} *</label>
          </p-ifta-label>
          @if (hasError('country')) {
            <small class="error-message">{{ getErrorMessage('country') }}</small>
          }
        </div>

        <!-- Address Fields -->
        <div class="form-field-row">
          <div class="form-field">
            <p-float-label variant="in">
              <input
                type="text"
                id="street"
                pInputText
                formControlName="street"
                [placeholder]="'contact.streetPlaceholder' | translate"
                [class.error-input]="hasError('street')"
              />
              <label for="street">{{ 'contact.street' | translate }} *</label>
            </p-float-label>
            @if (hasError('street')) {
              <small class="error-message">{{ getErrorMessage('street') }}</small>
            }
          </div>
          <div class="form-field form-field--narrow">
            <p-float-label variant="in">
              <input
                type="text"
                id="streetNumber"
                pInputText
                formControlName="streetNumber"
                [placeholder]="'contact.streetNumberPlaceholder' | translate"
                [class.error-input]="hasError('streetNumber')"
              />
              <label for="streetNumber">{{ 'contact.streetNumber' | translate }} *</label>
            </p-float-label>
            @if (hasError('streetNumber')) {
              <small class="error-message">{{ getErrorMessage('streetNumber') }}</small>
            }
          </div>
        </div>

        <div class="form-field-row">
          <div class="form-field">
            <p-float-label variant="in">
              <input
                type="text"
                id="city"
                pInputText
                formControlName="city"
                [placeholder]="'contact.cityPlaceholder' | translate"
                [class.error-input]="hasError('city')"
              />
              <label for="city">{{ 'contact.city' | translate }} *</label>
            </p-float-label>
            @if (hasError('city')) {
              <small class="error-message">{{ getErrorMessage('city') }}</small>
            }
          </div>
          <div class="form-field form-field--narrow">
            <p-float-label variant="in">
              <input
                type="text"
                id="zip"
                pInputText
                formControlName="zip"
                [placeholder]="'contact.zipPlaceholder' | translate"
                [class.error-input]="hasError('zip')"
              />
              <label for="zip">{{ 'contact.zip' | translate }} *</label>
            </p-float-label>
            @if (hasError('zip')) {
              <small class="error-message">{{ getErrorMessage('zip') }}</small>
            }
          </div>
        </div>

        <!-- Message Field -->
        <div class="form-field">
          <p-float-label variant="in">
            <textarea
              id="message"
              pTextarea
              rows="5"
              formControlName="message"
              [placeholder]="'contact.messagePlaceholder' | translate"
              [class.error-input]="hasError('message')"
            ></textarea>
            <label for="message">{{ 'contact.message' | translate }} *</label>
          </p-float-label>
          @if (hasError('message')) {
            <small class="error-message">{{ getErrorMessage('message') }}</small>
          }
          @if (!hasError('message')) {
            <small class="hint-message">
              {{ 'contact.charactersCount' | translate: { count: contactForm.get('message')?.value?.length || 0 } }}
            </small>
          }
        </div>

        <!-- Data Consent Field -->
        <div class="form-field consent-field">
          <p-checkbox [binary]="true" formControlName="dataConsent" inputId="dataConsent" />
          <div class="consent-label-wrapper">
            <label for="dataConsent" class="consent-label">
              {{ 'contact.consent.prefix' | translate
              }}<a [routerLink]="['/privacy']" target="_blank" rel="noopener noreferrer" class="consent-link">{{
                'contact.consent.linkText' | translate
              }}</a
              >{{ 'contact.consent.suffix' | translate }}
            </label>
            <span class="consent-required">*</span>
          </div>
        </div>
        @if (hasError('dataConsent')) {
          <small class="error-message">{{ 'contact.errors.required' | translate }}</small>
        }

        <p-button
          [label]="'contact.submit' | translate"
          class="smartrecon-button"
          [disabled]="!contactForm.valid || isSubmitting"
          [loading]="isSubmitting"
          (onClick)="onSubmit()"
        />
      </form>
    </div>

    @if (submitted) {
      <div class="panel-container contact-panel">
        <div class="confirm-header">
          <span>{{ 'contact.confirmationTitle' | translate }}</span>
        </div>
        <div class="confirm-content">
          <span>{{ 'contact.confirmationMessage' | translate }}</span>
        </div>
      </div>
    }

    @if (error) {
      <div class="panel-container contact-panel error-panel">
        <div class="confirm-header error-header">
          <span>{{ 'contact.errorTitle' | translate }}</span>
        </div>
        <div class="confirm-content">
          <span>{{ errorMessage || ('contact.errorMessage' | translate) }}</span>
        </div>
      </div>
    }
  </div>
</div>
